(function () {
    'use strict';

    var imageMasking = {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/entities/components/imageMasking.html',
        controllerAs: 'vm',
        bindings: {
            url: '<',
            maskUrl: '<',
            onSave: '&',
            onClose: '&'
        },
        controller: ImageMaskingController
    };

    ImageMaskingController.$inject = ['$timeout', '$element', 'ImageService', 'QiniuToken'];
    function ImageMaskingController($timeout, $element, ImageService, QiniuToken) {
        var vm = this;
        vm.token = '';
        QiniuToken.get('get', {}, function (token) {
            vm.token = token;
        });
        vm.domain = localStorage.getItem('editor-domain');
        var CONFIG = {
            MASK_GREEN: { r: 16, g: 141, b: 254 },
            MAX_HISTORY: 20,
            MIN_ZOOM: 0.3, MAX_ZOOM: 5, ZOOM_STEP: 0.08,
            TOAST_DURATION: 1500,
            MAX_UPLOAD_BYTES: 20 * 1024 * 1024,
        };

        // ==================== UI 绑定属性 ====================
        vm.brushSize = 20;
        vm.hardness = 80;
        vm.opacity = 100;
        vm.toolMode = 'repair';
        vm.viewMode = 'original';
        vm.dragMode = false;
        vm.undoEnabled = false;
        vm.redoEnabled = false;
        vm.brushHintVisible = false;
        vm.popupVisible = false;
        vm.toastText = '';
        vm.toastVisible = false;

        // 滑块背景渐变
        function buildSliderBg(val, min, max) {
            var pct = (val - min) / (max - min) * 100;
            return 'linear-gradient(to right, #BABDC0 0%, #BABDC0 ' + pct + '%, #EAECF1 ' + pct + '%, #EAECF1 100%)';
        }
        vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
        vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
        vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);

        // ==================== 内部状态 ====================
        var state = {
            isDrawing: false,
            history: [], historyIndex: -1,
            displayW: 0, displayH: 0,
            originalImg: null, maskImg: null,
            initialMask: null,
            zoom: 1, panX: 0, panY: 0,
            isPanning: false, panStart: null, panScreenStart: null,
            spaceHeld: false,
            isPinching: false, pinchStartDist: 0, pinchLastMid: null,
        };

        // DOM 引用
        var imageCanvas, imageCtx, overlayCanvas, overlayCtx;
        var brushCursor, canvasWrapper, canvasContainer, loadingOverlay;
        var maskCanvas, maskCtx;
        var strokeCanvas, strokeCtx, strokeBaseCanvas, strokeBaseCtx;
        var canvasFloats;
        var brushTipCache = null, brushTipCacheKey = '';
        var hintTimer = null, toastTimer = null;
        var undoRedoDigestTimer = null;

        // ==================== 公开方法 ====================
        vm.close = function() { vm.onClose(); };

        vm.confirm = function() {
            if (!maskCanvas) { vm.onSave({ data: null }); return; }
            try {
                var w = maskCanvas.width, h = maskCanvas.height;
                var result = document.createElement('canvas');
                result.width = w; result.height = h;
                var rCtx = result.getContext('2d');
                rCtx.drawImage(imageCanvas, 0, 0);
                rCtx.globalCompositeOperation = 'destination-in';
                rCtx.drawImage(maskCanvas, 0, 0);
                
                var file = canvasToUploadFile(result, 'matting-result.png');
                
                uploadMattingFiles(file, createMaskFile(), function(result) {
                    vm.onSave({ data: result });
                }, function() {
                    console.error('抠图结果上传失败');
                    showToast('保存失败');
                });
            } catch (e) {
                console.error('抠图结果生成失败:', e);
                showToast('保存失败');
            }
        };
        
        function createMaskFile() {
            var w = maskCanvas.width, h = maskCanvas.height;
            var maskExport = document.createElement('canvas');
            maskExport.width = w; maskExport.height = h;
            var exportCtx = maskExport.getContext('2d', { willReadFrequently: true });
            var maskData = maskCtx.getImageData(0, 0, w, h);
            var out = exportCtx.createImageData(w, h);
            for (var i = 0; i < maskData.data.length; i += 4) {
                var alpha = maskData.data[i + 3];
                var gray = alpha === 0 ? 0 : (alpha === 255 ? 255 : Math.round(30 + alpha * 180 / 255));
                out.data[i] = gray;
                out.data[i + 1] = gray;
                out.data[i + 2] = gray;
                out.data[i + 3] = 255;
            }
            exportCtx.putImageData(out, 0, 0);
            return canvasToUploadFile(maskExport, 'matting-mask.png');
        }

        function uploadMattingFiles(resultFile, maskFile, onSuccess, onError) {
            Promise.all([resultFile, maskFile]).then(function(files) {
                ImageService.backendUploadPics(files[0], vm.domain, vm.token, function(resultData) {
                    var resultUrl = vm.domain + resultData.key;
                    ImageService.backendUploadPics(files[1], vm.domain, vm.token, function(maskData) {
                        onSuccess({
                            url: resultUrl,
                            maskUrl: vm.domain + maskData.key
                        });
                    }, onError);
                }, onError);
            }).catch(onError);
        }

        function canvasToUploadFile(canvas, filename) {
            return canvasToBlob(canvas, filename).then(function(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES) {
                    return blobToFile(blob, filename);
                }
                return compressCanvasToFile(canvas, filename, blob);
            });
        }

        function compressCanvasToFile(sourceCanvas, filename, sourceBlob) {
            var currentCanvas = sourceCanvas;
            function compress(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES || currentCanvas.width <= 1 || currentCanvas.height <= 1) {
                    return blobToFile(blob, filename);
                }
                var scale = Math.sqrt(CONFIG.MAX_UPLOAD_BYTES / blob.size) * 0.92;
                scale = Math.max(0.1, Math.min(0.92, scale));
                var nextW = Math.max(1, Math.floor(currentCanvas.width * scale));
                var nextH = Math.max(1, Math.floor(currentCanvas.height * scale));
                if (nextW === currentCanvas.width && nextW > 1) nextW--;
                if (nextH === currentCanvas.height && nextH > 1) nextH--;

                var nextCanvas = document.createElement('canvas');
                nextCanvas.width = nextW;
                nextCanvas.height = nextH;
                nextCanvas.getContext('2d').drawImage(currentCanvas, 0, 0, nextW, nextH);
                currentCanvas = nextCanvas;
                return canvasToBlob(currentCanvas, filename).then(compress);
            }
            return compress(sourceBlob);
        }

        function canvasToBlob(canvas, filename) {
            return new Promise(function(resolve, reject) {
                if (canvas.toBlob) {
                    canvas.toBlob(function(blob) {
                        if (blob) resolve(blob);
                        else reject(new Error('canvas toBlob failed'));
                    }, 'image/png');
                    return;
                }
                try {
                    resolve(dataURLtoFile(canvas.toDataURL('image/png'), filename));
                } catch (error) {
                    reject(error);
                }
            });
        }

        function blobToFile(blob, filename) {
            return new File([blob], filename, { type: blob.type || 'image/png' });
        }

        function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }

        vm.setToolMode = function(mode) {
            if (vm.toolMode === mode && vm.popupVisible) {
                vm.popupVisible = false;
                return;
            }
            vm.toolMode = mode;
            vm.popupVisible = true;
            if (vm.dragMode) {
                vm.dragMode = false;
                overlayCanvas.style.cursor = 'none';
                brushCursor.style.display = 'block';
            }
        };

        vm.toggleDragMode = function() {
            vm.dragMode = !vm.dragMode;
            if (vm.dragMode) {
                stopDrawing();
                vm.popupVisible = false;
                overlayCanvas.style.cursor = 'grab';
                brushCursor.style.display = 'none';
            } else {
                overlayCanvas.style.cursor = 'none';
                brushCursor.style.display = 'block';
            }
        };

        vm.zoomReset = function() {
            state.zoom = 1;
            state.panX = 0;
            state.panY = 0;
            invalidateBrushCache();
            updateTransform();
            updateBrushCursor();
            showToast('1:1');
        };

        vm.switchView = function(mode) {
            if (vm.viewMode === mode) return;
            vm.viewMode = mode;
            renderCurrentView();
            showToast(mode === 'original' ? '原图编辑' : '效果图编辑');
        };

        vm.undo = function() { undo(); };
        vm.redo = function() { redo(); };
        vm.resetMask = function() {
            if (!state.maskImg) return;
            vm.zoomReset();
            pushHistory();
            initMaskFromImage(state.maskImg);
            renderCurrentView();
            showToast('已重置');
        };

        vm.onBrushSizeChange = function() {
            vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
            invalidateBrushCache(); showBrushSizeHint();
        };
        vm.onHardnessChange = function() {
            vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
            invalidateBrushCache();
        };
        vm.onOpacityChange = function() {
            vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);
        };

        // ==================== Toast ====================
        function showToast(msg) {
            vm.toastText = msg;
            vm.toastVisible = true;
            if (toastTimer) $timeout.cancel(toastTimer);
            toastTimer = $timeout(function() {
                vm.toastVisible = false;
            }, CONFIG.TOAST_DURATION);
        }

        // ==================== 初始化 ====================
        function init() {
            var el = $element[0];
            imageCanvas = el.querySelector('#imImageCanvas');
            imageCtx = imageCanvas.getContext('2d');
            overlayCanvas = el.querySelector('#imOverlayCanvas');
            overlayCtx = overlayCanvas.getContext('2d');
            brushCursor = el.querySelector('#imBrushCursor');
            canvasWrapper = el.querySelector('#imCanvasWrapper');
            canvasContainer = el.querySelector('#imCanvasContainer');
            loadingOverlay = el.querySelector('#imLoadingOverlay');
            canvasFloats = el.querySelectorAll('.im-view-toggle, .im-undo-redo, .im-zoom-group');

            setupEvents();
            updateBrushCursor();
            brushCursor.style.display = 'none';
            loadImages();
        }

        // ==================== 图片加载 ====================
        function loadImage(src) {
            return new Promise(function(resolve, reject) {
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = function() { resolve(img); };
                img.onerror = reject;
                img.src = src;
            });
        }

        function initMaskFromImage(maskImg) {
            var w = maskCanvas.width, h = maskCanvas.height;
            var tmp = document.createElement('canvas');
            tmp.width = w; tmp.height = h;
            var tCtx = tmp.getContext('2d', { willReadFrequently: true });
            tCtx.drawImage(maskImg, 0, 0, w, h);
            var data = tCtx.getImageData(0, 0, w, h).data;
            var out = maskCtx.createImageData(w, h);
            for (var i = 0; i < data.length; i += 4) {
                var bright = (data[i] + data[i + 1] + data[i + 2]) / 3;
                out.data[i] = CONFIG.MASK_GREEN.r;
                out.data[i + 1] = CONFIG.MASK_GREEN.g;
                out.data[i + 2] = CONFIG.MASK_GREEN.b;
                if (bright < 30) out.data[i + 3] = 0;
                else if (bright > 210) out.data[i + 3] = 255;
                else out.data[i + 3] = Math.floor(255 * (bright - 30) / 180);
            }
            maskCtx.putImageData(out, 0, 0);
        }

        function loadImages() {
            Promise.all([
                loadImage(vm.url),
                loadImage(vm.maskUrl)
            ]).then(function(results) {
                var orig = results[0], mask = results[1];
                state.originalImg = orig; state.maskImg = mask;

                var cr = canvasContainer.getBoundingClientRect();
                var cW = cr.width - 16, cH = cr.height - 16;
                var aspect = orig.width / orig.height;
                var dW, dH;
                if (cW / cH > aspect) { dH = cH; dW = dH * aspect; }
                else { dW = cW; dH = dW / aspect; }
                state.displayW = dW; state.displayH = dH;

                maskCanvas = document.createElement('canvas');
                maskCanvas.width = orig.width;
                maskCanvas.height = orig.height;
                maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });

                imageCanvas.width = orig.width;
                imageCanvas.height = orig.height;
                overlayCanvas.width = orig.width;
                overlayCanvas.height = orig.height;
                imageCanvas.style.width = dW + 'px';
                imageCanvas.style.height = dH + 'px';
                overlayCanvas.style.width = dW + 'px';
                overlayCanvas.style.height = dH + 'px';

                imageCtx.drawImage(orig, 0, 0);
                initMaskFromImage(mask);
                state.initialMask = document.createElement('canvas');
                state.initialMask.width = maskCanvas.width;
                state.initialMask.height = maskCanvas.height;
                state.initialMask.getContext('2d').drawImage(maskCanvas, 0, 0);
                renderOriginalView();
                pushHistory();
                loadingOverlay.style.display = 'none';
            }).catch(function(err) {
                loadingOverlay.innerHTML = '<span>加载失败，请刷新重试</span>';
                console.error(err);
            });
        }

        // ==================== 视图渲染 ====================
        function isCanvasReady() {
            return !!(maskCanvas && maskCtx && imageCanvas && overlayCanvas);
        }

        function syncOverlayFromMask() {
            if (!isCanvasReady()) return;
            overlayCtx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height);
            overlayCtx.drawImage(maskCanvas, 0, 0);
        }

        function renderCurrentView() {
            if (vm.viewMode === 'original') renderOriginalView();
            else renderEffectView();
        }

        function renderOriginalView() {
            imageCanvas.style.visibility = 'visible';
            syncOverlayFromMask();
            overlayCanvas.style.opacity = '0.5';
            overlayCanvas.style.display = 'block';
        }

        function renderEffectView() {
            var w = overlayCanvas.width, h = overlayCanvas.height;
            overlayCtx.clearRect(0, 0, w, h);
            overlayCtx.drawImage(imageCanvas, 0, 0);
            overlayCtx.globalCompositeOperation = 'destination-in';
            overlayCtx.drawImage(maskCanvas, 0, 0);
            overlayCtx.globalCompositeOperation = 'source-over';
            imageCanvas.style.visibility = 'hidden';
            overlayCanvas.style.opacity = '1';
            overlayCanvas.style.display = 'block';
        }

        // ==================== 画笔缓存 ====================
        function invalidateBrushCache() { brushTipCacheKey = ''; }

        function getBrushTip() {
            if (!isCanvasReady()) return null;
            var ratio = maskCanvas.width / state.displayW / state.zoom;
            var brushRadius = Math.max(1, vm.brushSize / 2 * ratio);
            var hardness = vm.hardness / 100;
            var innerR = brushRadius * hardness;
            var outerR = Math.max(brushRadius, innerR + 1);
            var size = Math.ceil(outerR * 2);
            var key = brushRadius.toFixed(2) + '|' + hardness.toFixed(2);

            if (brushTipCacheKey === key && brushTipCache) return { tip: brushTipCache, outerR: outerR };

            brushTipCacheKey = key;
            if (!brushTipCache || brushTipCache.width !== size || brushTipCache.height !== size) {
                brushTipCache = document.createElement('canvas');
                brushTipCache.width = size; brushTipCache.height = size;
            }
            var tctx = brushTipCache.getContext('2d');
            tctx.clearRect(0, 0, brushTipCache.width, brushTipCache.height);
            var cx = outerR, cy = outerR;
            var mc = CONFIG.MASK_GREEN;
            var solidColor = 'rgb(' + mc.r + ',' + mc.g + ',' + mc.b + ')';
            var fadeColor = 'rgba(' + mc.r + ',' + mc.g + ',' + mc.b + ',0)';
            if (innerR >= outerR - 0.5) {
                tctx.fillStyle = solidColor;
                tctx.beginPath(); tctx.arc(cx, cy, brushRadius, 0, Math.PI * 2); tctx.fill();
            } else {
                var grad = tctx.createRadialGradient(cx, cy, innerR, cx, cy, outerR);
                grad.addColorStop(0, solidColor);
                grad.addColorStop(1, fadeColor);
                tctx.fillStyle = grad;
                tctx.beginPath(); tctx.arc(cx, cy, outerR, 0, Math.PI * 2); tctx.fill();
            }
            return { tip: brushTipCache, outerR: outerR };
        }

        // ==================== 坐标与变换 ====================
        function updateTransform() {
            var t = 'scale(' + state.zoom + ') translate(' + state.panX + 'px, ' + state.panY + 'px)';
            canvasWrapper.style.transformOrigin = '0 0';
            canvasWrapper.style.transform = t;
        }

        function zoomAtPoint(clientX, clientY, newZoom) {
            newZoom = Math.max(CONFIG.MIN_ZOOM, Math.min(CONFIG.MAX_ZOOM, newZoom));
            var rect = canvasWrapper.getBoundingClientRect();
            var lx = (clientX - rect.left) / state.zoom;
            var ly = (clientY - rect.top) / state.zoom;
            state.panX = (lx + state.panX) * state.zoom / newZoom - lx;
            state.panY = (ly + state.panY) * state.zoom / newZoom - ly;
            state.zoom = newZoom;
            invalidateBrushCache();
            updateTransform();
            updateBrushCursor();
        }

        function getCanvasPos(e, rect) {
            if (!isCanvasReady()) return null;
            rect = rect || canvasWrapper.getBoundingClientRect();
            var clientX = e.touches ? e.touches[0].clientX : e.clientX;
            var clientY = e.touches ? e.touches[0].clientY : e.clientY;
            var ratio = maskCanvas.width / state.displayW;
            return {
                x: (clientX - rect.left) / state.zoom * ratio,
                y: (clientY - rect.top) / state.zoom * ratio,
            };
        }

        // ==================== 历史记录 ====================
        function pushHistory() {
            if (!isCanvasReady()) return;
            state.history.length = state.historyIndex + 1;
            var snap = document.createElement('canvas');
            snap.width = maskCanvas.width; snap.height = maskCanvas.height;
            snap.getContext('2d').drawImage(maskCanvas, 0, 0);
            state.history.push(snap);
            if (state.history.length > CONFIG.MAX_HISTORY) { state.history.shift(); }
            else { state.historyIndex = state.history.length - 1; }
            updateUndoRedoState();
        }

        function undo() {
            if (state.historyIndex <= 0) return;
            state.historyIndex--;
            restoreMaskFromHistory();
        }
        function redo() {
            if (state.historyIndex >= state.history.length - 1) return;
            state.historyIndex++;
            restoreMaskFromHistory();
        }
        function restoreMaskFromHistory() {
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(state.history[state.historyIndex], 0, 0);
            updateUndoRedoState();
            renderCurrentView();
        }
        function updateUndoRedoState() {
            vm.undoEnabled = state.historyIndex > 0;
            vm.redoEnabled = state.historyIndex < state.history.length - 1;
            scheduleUndoRedoDigest();
        }

        function scheduleUndoRedoDigest() {
            if (undoRedoDigestTimer) return;
            undoRedoDigestTimer = $timeout(function() {
                undoRedoDigestTimer = null;
            }, 0);
        }

        // ==================== 绘画核心 ====================
        function ensureStrokeCanvases() {
            if (!isCanvasReady()) return;
            if (strokeCanvas && strokeCanvas.width === maskCanvas.width && strokeCanvas.height === maskCanvas.height) return;
            strokeCanvas = document.createElement('canvas');
            strokeCanvas.width = maskCanvas.width;
            strokeCanvas.height = maskCanvas.height;
            strokeCtx = strokeCanvas.getContext('2d');

            strokeBaseCanvas = document.createElement('canvas');
            strokeBaseCanvas.width = maskCanvas.width;
            strokeBaseCanvas.height = maskCanvas.height;
            strokeBaseCtx = strokeBaseCanvas.getContext('2d');
        }

        function beginStroke() {
            ensureStrokeCanvases();
            if (!strokeCanvas || !strokeBaseCanvas) return;
            strokeBaseCtx.clearRect(0, 0, strokeBaseCanvas.width, strokeBaseCanvas.height);
            strokeBaseCtx.drawImage(maskCanvas, 0, 0);
            strokeCtx.clearRect(0, 0, strokeCanvas.width, strokeCanvas.height);
        }

        function drawBrushStamp(x, y) {
            var td = getBrushTip();
            if (!td || !strokeCtx) return;
            strokeCtx.drawImage(td.tip, x - td.outerR, y - td.outerR);
        }

        function renderStrokeToMask() {
            if (!isCanvasReady() || !strokeCanvas || !strokeBaseCanvas) return;
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(strokeBaseCanvas, 0, 0);
            maskCtx.save();
            maskCtx.globalAlpha = vm.opacity / 100;
            if (vm.toolMode === 'erase') maskCtx.globalCompositeOperation = 'destination-out';
            maskCtx.drawImage(strokeCanvas, 0, 0);
            maskCtx.restore();
        }

        function drawBrushAt(x, y) {
            drawBrushStamp(x, y);
        }

        function drawLine(from, to) {
            var dx = to.x - from.x, dy = to.y - from.y;
            var dist = Math.sqrt(dx * dx + dy * dy);
            if (dist === 0) { drawBrushAt(from.x, from.y); return; }
            var steps = Math.ceil(dist / 5);
            for (var i = 0; i <= steps; i++) {
                var t = i / steps;
                drawBrushAt(from.x + dx * t, from.y + dy * t);
            }
        }

        var pendingRafPos = null, lastRafDrawnPos = null, rafDrawId = null;

        function flushRafDraw() {
            rafDrawId = null;
            if (!state.isDrawing || !pendingRafPos) return;
            var target = pendingRafPos;
            pendingRafPos = null;
            if (lastRafDrawnPos) { drawLine(lastRafDrawnPos, target); }
            else { drawBrushAt(target.x, target.y); }
            lastRafDrawnPos = target;
            renderStrokeToMask();
            renderCurrentView();
        }

        function scheduleDraw(pos) {
            if (!state.isDrawing || !pos) return;
            pendingRafPos = pos;
            if (!rafDrawId) rafDrawId = requestAnimationFrame(flushRafDraw);
        }

        function startDrawing(e) {
            if (!isCanvasReady()) return;
            state.isDrawing = true;
            beginStroke();
            var pos = getCanvasPos(e);
            if (!pos) {
                state.isDrawing = false;
                return;
            }
            lastRafDrawnPos = pos;
            pendingRafPos = null;
            canvasFloats.forEach(function(el) { el.classList.add('im-float-hidden'); });
            $timeout(function() { vm.popupVisible = false; });
            scheduleDraw(pos);
        }

        function stopDrawing() {
            var hadDrawing = state.isDrawing || rafDrawId || pendingRafPos || lastRafDrawnPos;
            if (rafDrawId) {
                cancelAnimationFrame(rafDrawId);
                rafDrawId = null;
                if (pendingRafPos && lastRafDrawnPos) {
                    drawLine(lastRafDrawnPos, pendingRafPos);
                    renderStrokeToMask();
                }
            }
            state.isDrawing = false;
            pendingRafPos = null; lastRafDrawnPos = null;
            if (vm.viewMode === 'effect') {
                renderEffectView();
            } else {
                syncOverlayFromMask();
            }
            if (hadDrawing) pushHistory();
            canvasFloats.forEach(function(el) { el.classList.remove('im-float-hidden'); });
        }

        // ==================== 光标 ====================
        var lastMouseX = -1, lastMouseY = -1;

        function updateBrushCursor(e, rect) {
            rect = rect || canvasWrapper.getBoundingClientRect();
            var cx, cy;
            if (e) {
                cx = e.touches ? e.touches[0].clientX : e.clientX;
                cy = e.touches ? e.touches[0].clientY : e.clientY;
                lastMouseX = cx; lastMouseY = cy;
            } else if (lastMouseX >= 0) {
                cx = lastMouseX; cy = lastMouseY;
            } else {
                cx = rect.left + rect.width / 2; cy = rect.top + rect.height / 2;
            }
            brushCursor.style.left = ((cx - rect.left) / state.zoom) + 'px';
            brushCursor.style.top = ((cy - rect.top) / state.zoom) + 'px';
            var cs = vm.brushSize / state.zoom;
            brushCursor.style.width = cs + 'px'; brushCursor.style.height = cs + 'px';
        }

        function showBrushSizeHint() {
            vm.brushHintVisible = true;
            if (hintTimer) $timeout.cancel(hintTimer);
            hintTimer = $timeout(function() {
                vm.brushHintVisible = false;
            }, 800);
        }

        // ==================== 事件绑定 ====================
        function setupEvents() {
            // 滚轮缩放
            canvasContainer.addEventListener('wheel', function(e) {
                e.preventDefault();
                var d = e.deltaY > 0 ? -CONFIG.ZOOM_STEP : CONFIG.ZOOM_STEP;
                zoomAtPoint(e.clientX, e.clientY, state.zoom + d);
            }, { passive: false });

            // 鼠标
            overlayCanvas.addEventListener('mouseenter', function() {
                if (!state.spaceHeld && !vm.dragMode) brushCursor.style.display = 'block';
            });
            overlayCanvas.addEventListener('mouseleave', function() {
                stopDrawing(); brushCursor.style.display = 'none';
            });
            overlayCanvas.addEventListener('mousedown', function(e) {
                if (state.spaceHeld || vm.dragMode) {
                    state.isPanning = true;
                    state.panStart = { x: state.panX, y: state.panY };
                    state.panScreenStart = { x: e.clientX, y: e.clientY };
                    overlayCanvas.style.cursor = 'grabbing';
                    brushCursor.style.display = 'none';
                    $timeout(function() { vm.popupVisible = false; });
                    return;
                }
                startDrawing(e);
            });
            overlayCanvas.addEventListener('mousemove', function(e) {
                if (state.isPanning) {
                    state.panX = state.panStart.x + (e.clientX - state.panScreenStart.x) / state.zoom;
                    state.panY = state.panStart.y + (e.clientY - state.panScreenStart.y) / state.zoom;
                    updateTransform(); return;
                }
                var rect = canvasWrapper.getBoundingClientRect();
                updateBrushCursor(e, rect); scheduleDraw(getCanvasPos(e, rect));
            });
            overlayCanvas.addEventListener('mouseup', function() {
                if (state.isPanning) {
                    state.isPanning = false;
                    overlayCanvas.style.cursor = (vm.dragMode || state.spaceHeld) ? 'grab' : 'none';
                    if (!vm.dragMode && !state.spaceHeld) brushCursor.style.display = 'block';
                    return;
                }
                stopDrawing();
            });

            // 触摸
            function touchDist(e) {
                var dx = e.touches[0].clientX - e.touches[1].clientX;
                var dy = e.touches[0].clientY - e.touches[1].clientY;
                return Math.sqrt(dx * dx + dy * dy);
            }
            function touchMid(e) {
                return {
                    x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                    y: (e.touches[0].clientY + e.touches[1].clientY) / 2
                };
            }

            overlayCanvas.addEventListener('touchstart', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2) {
                    stopDrawing(); state.isPinching = true;
                    state.pinchStartDist = touchDist(e);
                    state.pinchLastMid = touchMid(e);
                    brushCursor.style.display = 'none';
                    $timeout(function() { vm.popupVisible = false; });
                    return;
                }
                if (vm.dragMode) {
                    state.isPanning = true;
                    state.panStart = { x: state.panX, y: state.panY };
                    state.panScreenStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
                    brushCursor.style.display = 'none';
                    $timeout(function() { vm.popupVisible = false; });
                    return;
                }
                brushCursor.style.display = 'block';
                updateBrushCursor(e); startDrawing(e);
            }, { passive: false });

            overlayCanvas.addEventListener('touchmove', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2 && state.isPinching) {
                    var nd = touchDist(e), mid = touchMid(e);
                    zoomAtPoint(mid.x, mid.y, state.zoom * (nd / state.pinchStartDist));
                    if (state.pinchLastMid) {
                        state.panX += (mid.x - state.pinchLastMid.x) / state.zoom;
                        state.panY += (mid.y - state.pinchLastMid.y) / state.zoom;
                        updateTransform();
                    }
                    state.pinchStartDist = nd; state.pinchLastMid = mid; return;
                }
                if (e.touches.length === 1 && state.isPanning) {
                    state.panX = state.panStart.x + (e.touches[0].clientX - state.panScreenStart.x) / state.zoom;
                    state.panY = state.panStart.y + (e.touches[0].clientY - state.panScreenStart.y) / state.zoom;
                    updateTransform(); return;
                }
                if (e.touches.length === 1 && !state.isPinching) {
                    var rect = canvasWrapper.getBoundingClientRect();
                    updateBrushCursor(e, rect); scheduleDraw(getCanvasPos(e, rect));
                }
            }, { passive: false });

            overlayCanvas.addEventListener('touchend', function(e) {
                if (e.touches.length === 0) {
                    state.isPinching = false; state.isPanning = false;
                    stopDrawing(); brushCursor.style.display = 'none';
                } else if (e.touches.length === 1 && state.isPinching) {
                    state.isPinching = false;
                }
            });

            // 键盘
            function onKeyDown(e) {
                if (e.target.tagName === 'INPUT') return;
                if (e.code === 'Space' && !state.spaceHeld) {
                    e.preventDefault(); state.spaceHeld = true;
                    stopDrawing();
                    overlayCanvas.style.cursor = 'grab';
                    brushCursor.style.display = 'none';
                }
                if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) { e.preventDefault(); undo(); }
                if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) { e.preventDefault(); redo(); }
            }
            function onKeyUp(e) {
                if (e.code === 'Space') {
                    state.spaceHeld = false; state.isPanning = false;
                    if (!vm.dragMode) {
                        overlayCanvas.style.cursor = 'none';
                        brushCursor.style.display = 'block';
                    }
                }
            }
            document.addEventListener('keydown', onKeyDown);
            document.addEventListener('keyup', onKeyUp);

            $element.on('$destroy', function() {
                document.removeEventListener('keydown', onKeyDown);
                document.removeEventListener('keyup', onKeyUp);
            });

            updateUndoRedoState();
        }

        // ==================== 启动 ====================
        $timeout(init);
    }

    angular
        .module('editorApp')
        .component('imageMasking', imageMasking);
})();
